/* eslint-disable react/display-name */
// * You should NOT edit this file directly. Read CONTRIBUTING.md for more information on creating icons
import { __assign } from "tslib";
import React from 'react';
import { forwardRef } from '../../helpers/forwardRef';
import { Icon } from '../../internal/Icon';
import { ArrowShapeALeftIcon16Light } from './ArrowShapeALeftIcon16Light';
import { ArrowShapeALeftIcon16Regular } from './ArrowShapeALeftIcon16Regular';
import { ArrowShapeALeftIcon16Solid } from './ArrowShapeALeftIcon16Solid';
import { ArrowShapeALeftIcon20Light } from './ArrowShapeALeftIcon20Light';
import { ArrowShapeALeftIcon20Regular } from './ArrowShapeALeftIcon20Regular';
import { ArrowShapeALeftIcon20Solid } from './ArrowShapeALeftIcon20Solid';
import { ArrowShapeALeftIcon24Regular } from './ArrowShapeALeftIcon24Regular';
import { ArrowShapeALeftIcon24Solid } from './ArrowShapeALeftIcon24Solid';
import { ArrowShapeALeftIcon32Regular } from './ArrowShapeALeftIcon32Regular';
import { ArrowShapeALeftIcon64Regular } from './ArrowShapeALeftIcon64Regular';
var sizes = {
    16: {
        light: ArrowShapeALeftIcon16Light,
        regular: ArrowShapeALeftIcon16Regular,
        solid: ArrowShapeALeftIcon16Solid,
    },
    20: {
        light: ArrowShapeALeftIcon20Light,
        regular: ArrowShapeALeftIcon20Regular,
        solid: ArrowShapeALeftIcon20Solid,
    },
    24: {
        regular: ArrowShapeALeftIcon24Regular,
        solid: ArrowShapeALeftIcon24Solid,
    },
    32: {
        regular: ArrowShapeALeftIcon32Regular,
    },
    64: {
        regular: ArrowShapeALeftIcon64Regular,
    },
};
export var ArrowShapeALeftIcon = forwardRef('ArrowShapeALeftIcon', function (props, ref) {
    return React.createElement(Icon, __assign({ ref: ref }, props, { sizes: sizes }));
});
